import Fase from "../../../../../components/categories/siakad/lms/data_matpel/subpage/fase/Home";
export default function Home() {
  
  return (
    <Fase />
  );
}
